import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img1 from "./img/img1.png";

export const YouAreAmazing = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img1} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>You're amazing! </h4>
          <p className={styles.description}>
            Many people often grapple with the fear of not being good enough.
            That is natural.
          </p>
          <p className={styles.descriptionStrong}>
            We'll take this into account and create a plan to empower you!
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
